export const selectTranslationKeys = {
  selectAll: 'select.all',
  selectClear: 'select.clear',
  selectNotSelected: 'select.not-selected',
  selectPlaceholder: 'select.placeholder',
  selectSelectAll: 'select.select-all',
  selectSelected: 'select.selected',
}
